import { Modal } from "flowbite-react";
import { useCallback, useMemo, useState } from "react";
import ComboBoxFormik from "../../../../../common/components/form/ComboBoxFormik";
import { FormikProvider, useFormik } from "formik";
import { numberToCurrency } from "../../../../../common/helpers/currency.helpers";
import InputFormik from "../../../../../common/components/form/InputFormik";
import { maskCurrency } from "../../../../../common/helpers/mask.helpers";
import ButtonWithLoader from "../../../../../common/components/ui/loading/ButtonLoading";
import { createAssasBooking } from "../../../services/integration.api";
import { useToastContext } from "../../../../../common/components/ui/toast/toast.context";
import { createDebounce } from "../../../../../common/helpers/debounce.helper";

type Props = {
  renter: { _id: string, name: string }
  onClose: () => void
}

export function ModalReservePayment(props: Props) {
  const [paymentMethod, setPaymentMethod] = useState('-');
  const [deposit, setDeposit] = useState(0);
  const { notifySuccess, notifyError } = useToastContext();
  const [selectedInstallmentOption, setSelectedInstallmentOption] = useState('0');
  const [depositInstallments, setDepositInstallments] = useState(0);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handlePaymentMethodChange = useCallback((selectedOption: any) => {
    setPaymentMethod(selectedOption);
  }, []);

  const handleInstallmentOptionChange = useCallback((option) => {
    setSelectedInstallmentOption(option);
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandleDepositChange = useCallback(
    createDebounce((event: React.ChangeEvent<HTMLInputElement>) => {
      const methodPayment = paymentMethod;
      const newValue = parseFloat(event.target.value.replace(/\D/g, "")) / 100;
      setDepositInstallments(newValue);
      if (newValue >= 200) {
        const valueCredit = methodPayment === 'credit' ? newValue + 50 : newValue;
        setDeposit(valueCredit);
      } else {
        notifyError("O valor mínimo para pagamento é de R$ 200,00");
        setDeposit(0);
      }
    }, 300),
    [setDeposit, paymentMethod, notifyError] // Certifique-se de que todas as dependências estão listadas aqui
  );

  const initialValues = {
    renterId: props.renter._id,
  }

  const formik = useFormik({
    initialValues,
    // validationSchema,
    onSubmit: async (data) => {

      const activationData = {
        renterId: data.renterId,
        paymentMethod: paymentMethod,
        deposit: deposit,
        reference: 'reserve',
        description: "LOCAVIBE RESERVA PARA LOCACAO DE MOTOCICLETA",
        installmentOptions: selectedInstallmentOption,
        depositInstallments: depositInstallments
      }
      const result = await createAssasBooking(activationData)
      if (!result.ok) {
        notifyError("Erro ao gerar cobrança no Assas")
        return
      }

      notifySuccess("Cobranças no Assas geradas com sucesso!")
    }
  })

  const paymentOptions = [
    { value: "-", label: "-" },
    { value: "pix", label: "PIX" },
    { value: "credit", label: "CRÉDITO" },
  ];

  const installmentOptions = useMemo(() => {
    if (deposit === 0) return [];

    return [
      { value: '-', label: `-` },
      { value: '1', label: `1 x R$ ${numberToCurrency((deposit / 1).toFixed(2))}` },
      { value: '2', label: `2 x R$ ${numberToCurrency((deposit / 2).toFixed(2))}` },
      { value: '3', label: `3 x R$ ${numberToCurrency((deposit / 3).toFixed(2))}` },
    ];
  }, [deposit]);

  const isButtonEnabled = deposit >= 200;


  return (
    <Modal
      className="text-black dark:text-black"
      show={true}
      onClose={() => props.onClose()}
    >
      <form onSubmit={formik.handleSubmit}>
        <FormikProvider value={formik}>
          <Modal.Header>
            <h2 className="dark:text-black">Gerar reserva para:  {props.renter.name}</h2>
          </Modal.Header>
          <Modal.Body>
            <ComboBoxFormik
              name="reserveDepositInstallments"
              label="Escolha o método de pagamento:"
              options={paymentOptions}
              required={true}
              onChange={handlePaymentMethodChange} // Usar a função corrigida
            />
            {paymentMethod === 'credit' && (
              <div>

                <div className="bg-yellowPrimary/20 border-l-4 border-yellow-500 p-4" role="alert">
                  <p>
                    Informa o cliente que para todo pagamento na opção de crédito será cobrado um valor adicional de R$ 50,00 sobre o valor total.
                  </p>
                </div>
                <InputFormik className="mt-6"
                  name="depositInstallments"
                  label="Digite o valor da reserva"
                  required={true}
                  onChange={debouncedHandleDepositChange}
                  mask={maskCurrency}
                />
                <ComboBoxFormik
                  name="installmentOption"
                  label="Escolha a opção de parcelamento:"
                  options={installmentOptions}
                  required={true}
                  onChange={handleInstallmentOptionChange}

                />
              </div>
            )}
            {paymentMethod === 'pix' && (
              <div>
                <InputFormik
                  name="depositInstallments"
                  label="Digite o valor da reserva"
                  required={true}
                  onChange={debouncedHandleDepositChange}
                  mask={maskCurrency}
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="justify-end h-16 pb-8">
            <ButtonWithLoader
              isLoading={formik.isSubmitting}
              onClick={formik.handleSubmit}
              disabled={!isButtonEnabled} // Desabilita o botão se o depósito for menor que   200
            >
              Gerar
            </ButtonWithLoader>
          </Modal.Footer>

        </FormikProvider>
      </form>
    </Modal >
  );
}